import { createEnv } from '@t3-oss/env-nextjs';
import z from 'zod';

const environmentSchema = z.enum(['development', 'staging', 'production']);

export const env = createEnv({
  client: {
    NEXT_PUBLIC_SUPABASE_URL: z.string().min(1),
    NEXT_PUBLIC_SUPABASE_ANON_KEY: z.string().min(1),
    NEXT_PUBLIC_ENVIRONMENT: environmentSchema,
    NEXT_PUBLIC_HUBSPOT_PORTAL_ID: z.string().min(1),
    NEXT_PUBLIC_HUBSPOT_PORTAL_ENVIRONMENT: environmentSchema.optional(),
    NEXT_PUBLIC_SITE_URL: z.url().min(1),
    NEXT_PUBLIC_POSTHOG_KEY: z.string().min(1),
    NEXT_PUBLIC_POSTHOG_HOST: z.url().default('https://eu.i.posthog.com'),
    NEXT_PUBLIC_CONTACT_RECIPIENT_EMAIL: z.email(),
    NEXT_PUBLIC_TOLD_WIDGET_ID: z.string().min(1),
    NEXT_PUBLIC_SERVICE_ACCOUNT_EMAIL: z.email(),
  },
  server: {
    // Database
    DATABASE_URL: z.string().min(1),

    // Supabase
    SUPABASE_SERVICE_ROLE_KEY: z.string().min(1),

    // Cron Authentication
    CRON_SECRET: z.string().optional(),

    // Google APIs
    SERVICE_ACCOUNT_PRIVATE_KEY: z.string().min(1),
    GOOGLE_PLACES_API_KEY: z.string().min(1),
    GOOGLE_DRIVE_TEMPLATE_FOLDER_ID: z.string().min(1),
    GOOGLE_DRIVE_CLIENTS_FOLDER_ID: z.string().min(1),
    BUSINESS_PLAN_TEMPLATE_SPREADSHEET_ID: z.string().min(1),

    // Pappers API
    PAPPERS_API_KEY: z.string().min(1),

    // Switchgrid
    SWITCHGRID_BEARER_TOKEN: z.string().min(1),

    // Notion
    NOTION_API_KEY: z.string().min(1),
    NOTION_DATABASE_ID: z.string().min(1),
    NOTION_MARCEL_NOTES_DATA_SOURCE_ID: z.string().min(1),

    // Huawei
    HUAWEI_DOMAIN_URL: z.url().min(1),
    HUAWEI_USERNAME: z.string().min(1),
    HUAWEI_PASSWORD: z.string().min(1),

    // SolarEdge
    SOLAR_EDGE_API_BASE_URL: z.url().min(1),
    SOLAR_EDGE_API_KEY: z.string().min(1),

    // Anthropic
    ANTHROPIC_API_KEY: z.string().min(1),

    // Resend
    RESEND_API_KEY: z.string().min(1),

    // Slack
    SLACK_BOT_TOKEN: z.string().min(1),

    // HubSpot
    HUBSPOT_ACCESS_TOKEN: z.string().min(1),

    /* Signs the collection form links handed to clients. A distinct value per environment is what
       keeps a staging link from opening on production. */
    QUALIFICATION_FORM_LINK_SECRET: z.string().min(32),

    // Enrise Enedis Automation
    ENRISE_ENEDIS_AUTOMATION_URL: z.url().min(1),
    ENRISE_ENEDIS_AUTOMATION_TOKEN: z.string().min(32),

    // Enrise API Keys (comma-separated)
    ENRISE_API_KEYS: z.string().min(1),

    // OpenWeather
    OPENWEATHER_API_KEY: z.string().min(1),

    // S3 Storage (optional for now since no values in .env)
    S3_HOST: z.string().min(1).optional(),
    S3_REGION: z.string().min(1).optional(),
    S3_ACCESS_KEY: z.string().min(1).optional(),
    S3_SECRET_KEY: z.string().min(1).optional(),
  },
  emptyStringAsUndefined: true,
  experimental__runtimeEnv: {
    NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
    NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
    NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
    NEXT_PUBLIC_HUBSPOT_PORTAL_ID: process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID,
    NEXT_PUBLIC_HUBSPOT_PORTAL_ENVIRONMENT:
      process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ENVIRONMENT,
    NEXT_PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    NEXT_PUBLIC_CONTACT_RECIPIENT_EMAIL:
      process.env.NEXT_PUBLIC_CONTACT_RECIPIENT_EMAIL,
    NEXT_PUBLIC_TOLD_WIDGET_ID: process.env.NEXT_PUBLIC_TOLD_WIDGET_ID,
    NEXT_PUBLIC_SERVICE_ACCOUNT_EMAIL:
      process.env.NEXT_PUBLIC_SERVICE_ACCOUNT_EMAIL,
  },
});
